'use strict';

// Import Libraries
import React     from 'react';
// Import JS Modules
import { builderDispatch, PrismUI } from '../../../_utils/ui';
// Import JSX Modules

// -----------------------------------------------------------

class FullScreenSpinnerBase extends React.PureComponent {
  constructor(props = {}) {
    super(props);

    this.state = {
      visible: !!props.show
    };
  }

  componentDidMount() {
    this.dispatchToken = builderDispatch.register(payload => {
      switch (payload.type) {
        case PrismUI.MODAL_MESSAGE:
          this.handleMessage(payload);
          break;
      }
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.hasOwnProperty('show')) {
      this.setState(() => ({
        visible: !!nextProps.show
      }));
    }
  }

  componentWillUnmount() {
    builderDispatch.unregister(this.dispatchToken);
  }

  handleMessage({action='show'}) {
    this.setState(() => ({
      visible: action === 'show'
    }));
  }
}

// -----------------------------------------------------------

export default FullScreenSpinnerBase;
